<script lang="ts">
  import { api, type CallListItem, type CallRow } from "../lib/api";

  let { c, showLead = false }: { c: CallRow | CallListItem; showLead?: boolean } = $props();

  let open = $state(false);
  let transcript = $state<string | null | undefined>(undefined);
  let loading = $state(false);

  const item = $derived(c as CallListItem);

  function when(iso: string) {
    return new Date(iso).toLocaleString("ru-RU", {
      day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Moscow",
    });
  }
  const dur = (s: number) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
  const ago = (m: number) => (m < 60 ? `${m} мин` : `${Math.floor(m / 60)} ч ${m % 60 ? `${m % 60} мин` : ""}`.trim());

  async function toggleTranscript() {
    open = !open;
    if (open && transcript === undefined) {
      loading = true;
      try {
        transcript = (await api.callDetail(c.id)).transcript;
      } catch {
        transcript = null;
      } finally {
        loading = false;
      }
    }
  }
</script>

<div class="call" class:bad={c.is_bad} class:missed={item.missed && item.callback_min == null}>
  <div class="head">
    <svg class="dir" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round" aria-label={c.direction === "in" ? "входящий" : "исходящий"}>
      {#if c.direction === "in"}<path d="M17 7L7 17M7 9v8h8"/>{:else}<path d="M7 17L17 7M9 7h8v8"/>{/if}
    </svg>
    <span class="meta">{when(c.called_at)}{#if c.manager_name} · {c.manager_name}{/if}</span>
    {#if c.answered}<span class="dur">{dur(c.duration_sec)}</span>{:else}<span class="miss">пропущен</span>{/if}
    {#if c.score != null}<span class="score" class:low={c.is_bad}>{c.score}/10</span>{/if}
  </div>
  {#if showLead}
    <div class="lead">
      {#if c.lead_amo_id}<a href={`?deal=${c.lead_amo_id}`}>{item.lead_name ?? "сделка"}</a>{/if}
      {#if c.phone}<a class="tel" href={`tel:${c.phone}`}>{c.phone}</a>{/if}
    </div>
  {/if}
  {#if item.missed}
    {#if item.callback_min != null}
      <div class="line ok">Перезвонили через {ago(item.callback_min)}</div>
    {:else}
      <div class="line warn">Не перезвонили</div>
    {/if}
  {/if}
  {#if c.summary}<div class="summary">{c.summary}</div>{/if}
  {#if c.next_step}<div class="line"><b>Договорились:</b> {c.next_step}</div>{/if}
  {#if c.is_bad && c.verdict}<div class="line warn">{c.verdict}</div>{/if}
  {#if c.record_url && c.answered}
    <audio controls preload="none" src={c.record_url}></audio>
  {/if}
  {#if c.has_transcript}
    <button class="link" type="button" onclick={toggleTranscript}>
      {open ? "Скрыть расшифровку" : "Расшифровка"}
    </button>
    {#if open}
      <div class="transcript">
        {#if loading}загружаю…{:else}{transcript ?? "не удалось загрузить"}{/if}
      </div>
    {/if}
  {/if}
</div>

<style>
  .call {
    background: var(--bg-elev);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 12px 14px;
  }
  .call.bad, .call.missed { border-color: var(--danger); }
  .head { display: flex; align-items: center; gap: 8px; font-size: 12px; color: var(--text-mute); }
  .dir { width: 16px; height: 16px; flex-shrink: 0; color: var(--text-mute); }
  .meta { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dur { font-variant-numeric: tabular-nums; }
  .miss { color: var(--danger); }
  .score {
    font-weight: 700; color: var(--text);
    background: var(--bg-elev-2); border-radius: 8px; padding: 2px 7px;
  }
  .score.low { background: var(--danger); color: #fff; }
  .lead { margin-top: 6px; display: flex; gap: 10px; flex-wrap: wrap; font-size: 13px; }
  .lead a { color: var(--ember); text-decoration: none; font-weight: 600; }
  .lead a.tel { color: var(--text-mute); font-weight: 500; }
  .summary { margin-top: 8px; font-size: 14px; line-height: 1.4; color: var(--text); }
  .line { margin-top: 6px; font-size: 13px; line-height: 1.4; color: var(--text-mute); }
  .line b { color: var(--text); font-weight: 600; }
  .line.warn { color: var(--danger); }
  .line.ok { color: var(--text-mute); }
  audio { width: 100%; height: 36px; margin-top: 10px; }
  .link {
    background: none; border: none; padding: 8px 0 0;
    color: var(--ember); font-size: 13px; font-weight: 600; cursor: pointer;
  }
  .link:active { opacity: 0.6; }
  .transcript {
    margin-top: 8px; padding: 10px 12px;
    background: var(--bg-elev-2); border-radius: 10px;
    font-size: 13px; line-height: 1.5; color: var(--text);
    white-space: pre-wrap; max-height: 320px; overflow-y: auto;
  }
</style>
